import React from 'react';

import { InputAction, CloseIcon } from '@gogame/components';

import { useFiltersFields } from '../FilterFieldsManager';
import { useFiltersStateManager } from '../FiltersStateManager';

const ClearPrimaryFilter = ({ name, fontSize }) => {
  const { fields } = useFiltersFields({ name });
  const {
    collection,
    setFilterValues,
    setFilterValue,
    getFilterEmptyValue,
    getFilterValue,
  } = useFiltersStateManager();

  const handleClearFilter = () => {
    if (collection) {
      setFilterValues(
        fields.map(({ collectionPath, path, basePath }) => {
          const emptyValue = getFilterEmptyValue(path);
          return {
            ...getFilterValue(collectionPath),
            [name]:
              emptyValue != null ? emptyValue : getFilterEmptyValue(basePath),
          };
        })
      );
    } else {
      const { path } = fields[0];

      setFilterValue(path, getFilterEmptyValue(path));
    }
  };

  return (
    <InputAction
      icon={<CloseIcon />}
      tooltip={'Clear filter'}
      onClick={handleClearFilter}
      fontSize={fontSize}
    />
  );
};

export default ClearPrimaryFilter;
